import React from 'react'

const InputPrimary = React.forwardRef(
  (
    { type = 'text', placeholder, value, onChange, className = '', ...props },
    ref
  ) => {
    return (
      <input
        ref={ref}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`w-full py-2 px-0 border-0 border-b border-primary focus:outline-none focus:ring-0 focus:border-b-1 focus:border-primary ${className}`}
        {...props}
      />
    )
  }
)

export default InputPrimary
